import React from "react";
import DisclaimerPopup from "./components/DisclaimerPopup";
import Navbar from "./components/Navbar";
import AboutUs from "./components/AboutUs";
import Practices from "./components/Practices";
import Blog from "./components/Blog";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import CarouselSection from "./components/CarouselSection";
import Foundation from "./components/Foundation";
import WhoWeAre from "./components/WhoWeAre";

import "./App.css";

function App() {
  return (
    <>
      <DisclaimerPopup />
      <Navbar />
      <main>
        <CarouselSection />
        <AboutUs />
        <Foundation />
        <WhoWeAre />
        <Practices />
        <Blog />
        <ContactUs />
      </main>
      <Footer />
    </>
  );
}

export default App;
